/**
 * Returns a safe getter function that will take an object and retrieve values
 * according to the provided array of keys and integers.
 * @param {array} path - contains keys or integers that describe a path of attributes to retrieve from.
 */
export default path => obj => path.reduce((accu, x) => (accu && accu[x] ? accu[x] : null), obj);
